<template>
  <div>
    <el-dialog title="结算账户信息" :visible.sync="dialogTableVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-form-item label="银行账号类型：" prop="bankAccountType">
          <el-select v-model="ruleForm.bankAccountType" placeholder="请选择银行账号类型">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="开户行：" prop="bankAccount">
          <el-select v-model="ruleForm.bankAccount" placeholder="请选择开户行">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行账户号码：" prop="bankAccountNum">
          <el-input v-model="ruleForm.bankAccountNum"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      ruleForm: {
        bankAccountType: "",
        bankAccount: "",
        bankAccountNum: ""
      },
      rules: {
        bankAccountType: [
          { required: true, message: "请选择银行账号类型", trigger: "change" },
        ],
        bankAccount: [
          { required: true, message: "请选择开户行", trigger: "change" },
        ],
        bankAccountNum: [
          { required: true, message: "请选择活动区域", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    init() {
      this.dialogTableVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogTableVisible = false
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-select {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/home/accountSet.vue